import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import { Button } from "scmp-app/components/posties/button";
import SvgPeter from "scmp-app/components/posties/form-drawer/svg-peter.svg";
import SvgErrorPeter from "scmp-app/components/posties/student-form/message-box/error-peter.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;

  padding-inline: 24px;
`;

export const StyledPeter = styled(SvgPeter)`
  margin-inline-end: 30px;
`;

export const StyledErrorPeter = styled(SvgErrorPeter)`
  margin-inline-end: 30px;
`;

export const TextWrapper = styled.div`
  margin-block-start: 21px;
  padding-inline: 36px;
`;

export const Title = styled.div`
  margin-block-end: 16px;

  color: #1b4191;
  font-size: 28px;
  font-family: ${fontAngkor};
  line-height: 34px;
  letter-spacing: -0.04em;
  text-align: center;
`;

export const ThankYouMessage = styled.div`
  margin-block-end: 32px;

  font-size: 16px;
  line-height: 22.4px;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  margin-block-end: 0;
  padding-block: 12px;
  padding-inline: 46px;

  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 12px;
    padding-inline: 46px;

    font-size: 16px;
    line-height: 20px;
  }
`;
